import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { ViewEncapsulation } from '@angular/core';
import { analyzeAndValidateNgModules } from '@angular/compiler';

@Component({
  selector: 'app-countrymaster',
  templateUrl: './countrymaster.component.html',
  styleUrls: ['./countrymaster.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CountrymasterComponent implements OnInit {

  CountryCode: string;
  CountryName: string;
  isShownError: boolean = true;
  isShownSuccess: boolean = true;
  public searchText: string;
  CountryExport = [] as any;
  EditedCountry = [] as any;
  EditedCountryId: string;
  Status: boolean = false;
  ErrorMsg: string;
  SuccessMsg: string;
  isShownSaveBtn: boolean = false;
  isShownUpdateBtn: boolean =true;
  isShownActive: Boolean = true;

  vRead: string;
  vWrite: string;
  isShownWrite: boolean = true;

  displayedColumns: string[] = ['sno', 'countrycode', 'countryname','status'];
  dataSource: MatTableDataSource<any[]>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.vRead = localStorage.getItem('CountryRead');
    this.vWrite = localStorage.getItem('CountryWrite');
    if ((this.vRead == undefined || this.vRead == "") && (this.vWrite == undefined || this.vWrite == ""))
      window.location.href = '/Dashboard';
    if (this.vWrite != undefined && this.vWrite != "") {
      if (this.vWrite == "True")
        this.isShownWrite = false;
    }

    this.BindCountryGrid();
    this.BindCountryExport();
  }

  SubmitCountry() {
    this.isShownError = true;
    this.isShownSuccess = true;   
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.Status =false;
    var vcountrycode = this.CountryCode;
    var vCountryName = this.CountryName;
    debugger;

    if (vcountrycode == undefined || vcountrycode == "" || vcountrycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country Code.";
      return false;
    }

    if (vcountrycode != undefined || vcountrycode == "" || vcountrycode == null) {
      var cntycode = vcountrycode.split("");
      for(var i=0 ;i<cntycode.length;i++)      
      {        
        if (!(cntycode[i] >= 'a' && cntycode[i] <= 'z' || cntycode[i] >= 'A' && cntycode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Country Code.";
          return false;
        }
      }      
    }

    if (vCountryName == undefined || vCountryName == "" || vCountryName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country Name.";
      return false;
    }


    let params = new HttpParams();
    params = params.append('dCountryCode', this.CountryCode);
    params = params.append('dCountryName', this.CountryName);
    var value = this.http.get(environment.apiUrl + 'Country/InsertCountry', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var countrycode = data;
        this.CountryCode = "";
        this.CountryName = "";
        this.SuccessMsg = "CountryMaster Added."  
        this.BindCountryGrid();
        this.BindCountryExport();
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Insert Failed, Please Try Again.";
          return false;
        }
        else if (vErrorMsg1 == "Exist") {
          this.isShownError = false;
          this.ErrorMsg = "Country Code and Country Name ,Already Exist";
          return false;
        }
        else {
        }
      });
  }

  EditCountry(item: any) {
    this.isShownSaveBtn = true;
    this.isShownUpdateBtn =false;
    this.isShownActive =false;
    this.EditedCountry = item;
    var vCountryId = this.EditedCountry.countryId;   
    var vcountrycode = this.EditedCountry.countrycode;
    var vCountryName = this.EditedCountry.countryname;
    
    this.EditedCountryId =vCountryId;
    this.CountryCode = vcountrycode;
    this.CountryName = vCountryName;
    var vStatus = this.EditedCountry.status;
    debugger;
    if(vStatus == "Active")
    {
      this.Status =false;
    }
    else
    {
      this.Status=true;
    }
  }

  UpdateCountry()
  {
    this.isShownError = true;
    this.isShownSuccess = true;    
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    var vcountrycode = this.CountryCode;
    var vCountryName = this.CountryName;
    debugger;

    if (vcountrycode == undefined || vcountrycode == "" || vcountrycode == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country Code.";
      return false;
    }

    if (vcountrycode != undefined || vcountrycode == "" || vcountrycode == null) {
      var cntycode = vcountrycode.split("");
      for(var i=0 ;i<cntycode.length;i++)      
      {        
        if (!(cntycode[i] >= 'a' && cntycode[i] <= 'z' || cntycode[i] >= 'A' && cntycode[i] <= 'Z')) {
          this.isShownError = false;
          this.ErrorMsg = "Please Enter valid Country Code.";
          return false;
        }
      }      
    }

    if (vCountryName == undefined || vCountryName == "" || vCountryName == "0") {
      this.isShownError = false;
      this.ErrorMsg = "Please Enter Country Name.";
      return false;
    }
    var vStatus = "Active";
    if (this.Status == true)
      vStatus = "InActive";
    else
      vStatus = "Active";

    let params = new HttpParams();
    params = params.append('iCountryCode', this.CountryCode);
    params = params.append('iCountryName', this.CountryName);
    params = params.append('iCountryId',this.EditedCountryId);
    params = params.append('istatus',vStatus);
    var value = this.http.get(environment.apiUrl + 'Country/UpdateCountry', { params: params }).toPromise().then(
      (data: any) => {
        debugger;
        var countrycode = data;
        this.SuccessMsg = "CountryMaster Updated."
        this.CountryCode = "";
        this.CountryName = "";     
        this.Status = false;     
        this.isShownSaveBtn = false;
        this.isShownUpdateBtn =true;
        this.isShownActive = false;   
        this.BindCountryGrid(); 
        this.BindCountryExport();   
        return false;
      }).catch((data: any) => {
        debugger;
        var vDataError = JSON.stringify(data.error.text);
        var vErrorMsg = vDataError.replace('"', '');
        var vErrorMsg1 = vErrorMsg.replace('"', '');
        if (vErrorMsg1 == "Failed") {
          this.isShownError = false;
          this.ErrorMsg = "Update Failed, Please Try Again.";
          return false;
        }
        else {
        }
      });


  }

  ClearCountry() {
    this.isShownError = true;
    this.isShownSuccess = true;
    this.isShownActive = true;
    this.isShownSaveBtn = false;
    this.isShownUpdateBtn =true;
    this.Status=false;
    this.ErrorMsg = "";
    this.SuccessMsg = "";
    this.CountryCode = "";
    this.CountryName = "";
  }


  BindCountryGrid() {
    var value = this.http.get(environment.apiUrl + 'Country/GetCountryForGrid').toPromise().then(
      (data: any) => {
        debugger;
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.data = data;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

      });
  }

  applyFilter(filterValue: string) {
    debugger;
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  BindCountryExport() {
    var value = this.http.get(environment.apiUrl + 'Country/GetCountryForExport').toPromise().then(
      (data: any) => {
        debugger;
        this.CountryExport = data;
      });
  }

  exportexcel(): void {
    debugger;
    /* table id is passed over here */
    const workSheet = XLSX.utils.json_to_sheet(this.CountryExport);
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, workSheet, 'Country');

    /* save to file */
    XLSX.writeFile(wb, "Country.xlsx");

  }

}
